import App from './App';

Vue.component(App.name, App);



// WEBPACK FOOTER //
// ./src/js/jikosaiten/index/index.js